import { IPromise } from 'angular'
import { ApiInventoryLevel, ApiProduct, ApiResponse } from '@vend/types'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

const PRODUCTS_ENDPOINT = '/api/2.0/products'

interface InventoryOptions {
  include_variants?: boolean
  location_ids?: string[]
}

/**
 * Functions for querying the products API for product data.
 */

/**
 * Requests data for a product from the api.
 *
 * @param productId
 *        The id of the product to retrieve
 *
 * @return A promise resolved when the product has been retrieved
 */
export function getProduct(productId: string): IPromise<ApiProduct> {
  return $http
    .get<ApiResponse<ApiProduct>>(`${PRODUCTS_ENDPOINT}/${productId}`)
    .then(extractData)
}

/**
 * @deprecated use the getInventory function in "./get-inventory.ts"
 */
export function getInventory(
  productIds: string[],
  options?: InventoryOptions
): IPromise<ApiInventoryLevel[]> {
  const optionsObject = {
    ...options,
    include_composites: true,
    product_ids: productIds,
    size: 1000,
  }
  const optionsString = JSON.stringify(optionsObject)

  return $http
    .get<ApiResponse<ApiInventoryLevel[]>>(`/api/2.0/inventory_levels`, {
      params: { options: optionsString },
    })
    .then(extractData)
}
